
import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { RestrictPermissionsGuard } from './shared/guards/restrict-permissions.guard';
import { AdminLayoutComponent } from './shared/layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './shared/layouts/auth/auth-layout.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';

export const AppRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },

  //  AUTH SECTION
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        loadComponent: () => import('./modules/auth/login/login.component').then(m => m.LoginComponent),
      },
    ],
  },

  // ADMIN SECTION - Dashboard, Assets & Sidebar routes
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: DashboardComponent,
        canActivate: [RestrictPermissionsGuard],
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'ordered-products' },
          {
            path: 'ordered-products',
            loadComponent: () => import('./modules/ordered-products/ordered-products.component').then(m => m.OrderedProductsComponent),
          },
          {
            path: 'table-assets',
            loadComponent: () => import('./modules/dashboard/dashboard-assets/table-assets/table-assets.component').then(m => m.TableAssetsComponent), 
          },
          {
            path: 'products',
            loadComponent: () => import('./modules/products/products.component').then(m => m.ProductsComponent),
          },
          {
            path: 'brand-profile',
            loadComponent: () => import('./modules/brand-profile/brand-profile.component').then(m => m.BrandProfileComponent),
          },
          {
            path: 'assets',
            loadComponent: () => import('./modules/assets/assets.component').then(m => m.AssetsComponent),
          },
          {
            path: 'allergens',
            loadComponent: () => import('./modules/allergens/allergens.component').then(m => m.AllergensComponent),
          },
          {
            path: 'categories',
            loadComponent: () => import('./modules/categories/categories.component').then(m => m.CategoriesComponent),
          },
          {
            path: 'types',
            loadComponent: () => import('./modules/types/types.component').then(m => m.TypesComponent),
          },
          {
            path: 'measurement-units',
            loadComponent: () => import('./modules/measurement-unit/measurement-units.component').then(m => m.MeasurementUnitsComponent),
          },
          {
            path: 'accounts',
            loadComponent: () => import('./modules/accounts/accounts.component').then(m => m.AccountsComponent),
          },
          {
            path: 'roles',
            loadComponent: () => import('./modules/roles/roles.component').then(m => m.RolesComponent),
          },
          {
            path: 'settings',
            loadComponent: () => import('./modules/settings/settings.component').then(m => m.SettingsComponent),
          },
          {
            path: 'orders',
            loadComponent: () => import('./modules/orders/orders.component').then(m => m.OrdersComponent),
          },
          {
            path: 'payments',
            loadComponent: () => import('./modules/payments/payments.component').then(m => m.PaymentsComponent),
          }
        ]
      }
    ]
  },

  //  WAITER SECTION
  {
    path: 'waiter-qr-scan',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'order-products',
        loadComponent: () => import('./modules/waiter-qr-scan/waiter-qr-scan.component').then(m => m.WaiterQrScanComponent),
      },
      {
        path: 'order-products/:id',
        loadComponent: () => import('./modules/waiter-qr-scan/waiter-qr-scan.component').then(m => m.WaiterQrScanComponent),
      }
    ]
  },

  // PUBLIC MENU SECTION
  {
    path: 'menu',
    loadComponent: () => import('./modules/qr-scan/qr-scan.component').then(m => m.QrScanComponent),
  },
  {
    path: 'menu/assets/:id',
    loadComponent: () => import('./modules/qr-scan/qr-scan.component').then(m => m.QrScanComponent),
  },

  // OTHERS
  {
    path: 'no-access',
    loadComponent: () => import('./modules/no-access/no-access.component').then(m => m.NoAccessComponent),
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];



// NOT WORKING
// import { Routes } from '@angular/router';
// import { AuthGuard } from './shared/guards/auth.guard';
// import { RestrictPermissionsGuard } from './shared/guards/restrict-permissions.guard';
// import { AdminLayoutComponent } from './shared/layouts/admin/admin-layout.component';
// import { AuthLayoutComponent } from './shared/layouts/auth/auth-layout.component';
// import { NoAccessComponent } from './modules/no-access/no-access.component';
// import { SettingsComponent } from './modules/settings/settings.component';
// import { MeasurementUnitsComponent } from './modules/measurement-unit/measurement-units.component';
// import { CategoriesComponent } from './modules/categories/categories.component';
// import { TypesComponent } from './modules/types/types.component';
// import { QrScanComponent } from './modules/qr-scan/qr-scan.component';
// import { DashboardComponent } from './modules/dashboard/dashboard.component';
// import { WaiterQrScanComponent } from './modules/waiter-qr-scan/waiter-qr-scan.component';

// export const AppRoutes: Routes = [
//   {
//     path: '',
//     pathMatch: 'full',
//     redirectTo: 'login',
//   },

//    // --- AUTH ---
//   {
//     path: '',
//     component: AuthLayoutComponent,
//     children: [
//       {
//         path: 'login',
//         loadComponent: () =>
//           import('./modules/auth/login/login.component').then(m => m.LoginComponent),
//       },
//     ],
//   },
//   {
//     path: 'qr-scan',
//     component: AdminLayoutComponent,
//     canActivate: [AuthGuard],
//     children: [
//         {
//             path: '',
//             loadComponent: () => 
//               import('./modules/waiter-qr-scan/waiter-qr-scan.component')
//             .then(m => m.WaiterQrScanComponent),
//         },
//     ]
//   },
//     // --- ADMIN ---
//   {
//   path: 'admin',
//   component: AdminLayoutComponent,   // First level: Sidebar/Header
//   canActivate: [AuthGuard],
//   children: [
//     {path: '', pathMatch: 'full', redirectTo:'ordered-products' },   // The dashboard displays the ordered-products
//     {
//       path: 'ordered-products',
//       // canActivate: [RestrictPermissionsGuard],
//       loadComponent: () =>
//         import('./modules/ordered-products/ordered-products.component')
//           .then(m => m.OrderedProductsComponent),
//     },
//     {
//       path: 'brand-profile',
//       loadComponent: () =>
//         import('./modules/brand-profile/brand-profile.component')
//           .then(m => m.BrandProfileComponent),
//     },
//     {
//       path: 'products',
//       loadComponent: () =>
//         import('./modules/products/products.component')
//           .then(m => m.ProductsComponent),
//     },
//     {
//       path: 'assets',
//       loadComponent: () =>
//         import('./modules/assets/assets.component')
//           .then(m => m.AssetsComponent),
//     },
//     {
//       path: 'allergens',
//       loadComponent: () =>
//         import('./modules/allergens/allergens.component')
//           .then(m => m.AllergensComponent),
//     },
//     {
//       path: 'measurement-units',
//       loadComponent: () =>
//         import('./modules/measurement-unit/measurement-units.component')
//           .then(m => m.MeasurementUnitsComponent),
//     },
//     {
//       path: 'types',
//       loadComponent: () =>
//         import('./modules/types/types.component')
//           .then(m => m.TypesComponent),
//     },
//     {
//       path: 'categories',
//       loadComponent: () =>
//         import('./modules/categories/categories.component')
//           .then(m => m.CategoriesComponent),
//     },
//     {
//       path: 'settings',
//       canActivate: [RestrictPermissionsGuard],
//       loadComponent: () =>
//         import('./modules/settings/settings.component')
//           .then(m => m.SettingsComponent),
//     },
//     {
//       path: 'accounts',
//       canActivate: [RestrictPermissionsGuard],
//       loadComponent: () =>
//         import('./modules/accounts/accounts.component')
//           .then(m => m.AccountsComponent),
//     },
//     {
//       path: 'roles',
//       canActivate: [RestrictPermissionsGuard],
//       loadComponent: () =>
//         import('./modules/roles/roles.component')
//           .then(m => m.RolesComponent),
//     },
//     {
//       path: 'orders',
//       loadComponent: () =>
//         import('./modules/orders/orders.component')
//           .then(m => m.OrdersComponent),
//     },
//     {
//       path: 'payments',
//       loadComponent: () =>
//         import('./modules/payments/payments.component')
//           .then(m => m.PaymentsComponent),
//     },
//     {
//       path: 'no-access',
//       loadComponent: () =>
//         import('./modules/no-access/no-access.component')
//           .then(m => m.NoAccessComponent),
//     }
//   ]
// },
// {
// path: '',
// loadChildren: () =>
//   import('./modules/qr-scan/qr-scan.routing')
//     .then(m => m.QRScanRoutes),
// },
// // --- FALLBACK ---
// { path: '**', redirectTo: 'login' },
// ];




// PREV - NOT WORKING
// import { Routes } from '@angular/router';
// import { AuthGuard } from './shared/guards/auth.guard';
// import { RestrictPermissionsGuard } from './shared/guards/restrict-permissions.guard';
// import { AdminLayoutComponent } from './shared/layouts/admin/admin-layout.component';
// import { AuthLayoutComponent } from './shared/layouts/auth/auth-layout.component';
// import { NoAccessComponent } from './modules/no-access/no-access.component';
// import { SettingsComponent } from './modules/settings/settings.component';
// import { MeasurementUnitsComponent } from './modules/measurement-unit/measurement-units.component';
// import { CategoriesComponent } from './modules/categories/categories.component';
// import { TypesComponent } from './modules/types/types.component';
// import { QrScanComponent } from './modules/qr-scan/qr-scan.component';
// import { DashboardComponent } from './modules/dashboard/dashboard.component';
// import { WaiterQrScanComponent } from './modules/waiter-qr-scan/waiter-qr-scan.component';

// export const AppRoutes: Routes = [
//   {
//     path: '',
//     pathMatch: 'full',
//     redirectTo: 'login',
//   },

//    // --- AUTH ---
//   {
//     path: '',
//     component: AuthLayoutComponent,
//     children: [
//       {
//         path: 'login',
//         loadComponent: () =>
//           import('./modules/auth/login/login.component').then(m => m.LoginComponent),
//       },
//     ],
//   },
//   {
//     path: 'qr-scan',
//     component: AdminLayoutComponent,
//     canActivate: [AuthGuard],
//     children: [
//         {
//             path: '',
//             loadComponent: () => 
//               import('./modules/waiter-qr-scan/waiter-qr-scan.component')
//             .then(m => m.WaiterQrScanComponent),
//         },
//     ]
//   },
//     // --- ADMIN ---
//   {
//     path: 'admin',
//     component: AdminLayoutComponent,
//     canActivate: [AuthGuard],
//     children: [
//       { path: '', pathMatch: 'full', redirectTo: 'ordered-products' },

//       {
//         path: 'dashboard',
//         redirectTo: 'ordered-products',
//         pathMatch: 'full'
//       },

//       {
//         path: 'ordered-products',
//         loadComponent: () =>
//           import('./modules/ordered-products/ordered-products.component')
//             .then(m => m.OrderedProductsComponent),
//       },
//       {
//         path: 'brand-profile',
//         loadComponent: () =>
//           import('./modules/brand-profile/brand-profile.component').then(m => m.BrandProfileComponent),
//       },
//       // {
//       //   path: 'brand-invoice-profile',
//       //   // canActivate: [RestrictPermissionsGuard],
//       //   loadComponent: () =>
//       //     import('./modules/brand-invoice-profile/brand-invoice-profile.component').then(m => m.BrandInvoiceProfileComponent),
//       // },
//       {
//         path: 'products',
//         // canActivate: [RestrictPermissionsGuard],
//         loadComponent: () =>
//           import('./modules/products/products.component').then(m => m.ProductsComponent),
//       },
//       {
//         path: 'assets',
//         // canActivate: [RestrictPermissionsGuard],
//         loadComponent: () =>
//           import('./modules/assets/assets.component').then(m => m.AssetsComponent),
//       },
//       {
//         path: 'allergens',
//         // canActivate: [RestrictPermissionsGuard],
//         loadComponent: () =>
//           import('./modules/allergens/allergens.component').then(m => m.AllergensComponent),
//       },
//       {
//         path: 'measurement-units',
//         // canActivate: [RestrictPermissionsGuard],
//         loadComponent: () =>
//           import('./modules/measurement-unit/measurement-units.component').then(m => m.MeasurementUnitsComponent),
//       },
//       {
//         path: 'types',
//         // canActivate: [RestrictPermissionsGuard],
//         loadComponent: () =>
//           import('./modules/types/types.component').then(m => m.TypesComponent),
//       },
//       {
//         path: 'categories',
//         // canActivate: [RestrictPermissionsGuard],
//         loadComponent: () =>
//           import('./modules/categories/categories.component').then(m => m.CategoriesComponent),
//       },
//       {
//         path: 'settings',
//         canActivate: [RestrictPermissionsGuard], // pentru permisiuni in functie de roluri, pe anumite rute sensibile
//         loadComponent: () =>
//           import('./modules/settings/settings.component').then(m => m.SettingsComponent),
//       },
//       { 
//         path: 'accounts',
//         canActivate: [RestrictPermissionsGuard],
//         loadComponent: () =>
//           import('./modules/accounts/accounts.component').then(m => m.AccountsComponent),
//       },
//       {
//         path: 'roles',
//         canActivate: [RestrictPermissionsGuard],
//         loadComponent: () =>
//           import('./modules/roles/roles.component').then(m => m.RolesComponent),
//       },

//       {
//         path: 'orders',
//         loadComponent: () =>
//           import('./modules/orders/orders.component').then(m => m.OrdersComponent),
//       },
//       {
//         path: 'payments',
//         loadComponent: () =>
//           import('./modules/payments/payments.component').then(m => m.PaymentsComponent),
//       },

//       {
//         path: 'no-access',
//         loadComponent: () =>
//           import('./modules/no-access/no-access.component').then(m => m.NoAccessComponent),
//       },
//     ],
//   },
//   {
//     path: 'menu',
//     loadComponent: () =>
//       import('./modules/qr-scan/qr-scan.component')
//         .then(m => m.QrScanComponent),
//   },
//   {
//     path: 'menu/assets/:id',
//     loadComponent: () =>
//       import('./modules/qr-scan/qr-scan.component')
//         .then(m => m.QrScanComponent),
//   },
//   {
//   path: '',
//   loadChildren: () =>
//     import('./modules/qr-scan/qr-scan.routing')
//       .then(m => m.QRScanRoutes),
//   },
// // --- FALLBACK ---
//   { path: '**', redirectTo: 'login' },
// ];





// import { Routes } from '@angular/router';
// import { AuthGuard } from './shared/guards/auth.guard';

// import { AdminLayoutComponent } from './shared/layouts/admin/admin-layout.component';
// import { AuthLayoutComponent } from './shared/layouts/auth/auth-layout.component';
// import { QrScanComponent } from './modules/qr-scan/qr-scan.component';
// import { NoAccessComponent } from './modules/no-access/no-access.component';
// import { DashboardComponent } from './modules/dashboard/dashboard.component';

// export const AppRoutes: Routes = [
//   {
//     path: '',
//     pathMatch: 'full',
//     redirectTo: 'login',
//   },
//   {
//     path: 'login',
//     loadComponent: () =>
//       import('./modules/auth/login/login.component').then(m => m.LoginComponent),
//   },
//   {
//     path: 'dashboard',
//     canActivate: [AuthGuard],
//     loadComponent: () =>
//       import('./modules/dashboard/dashboard.component').then(m => m.DashboardComponent)
//   },
//   // {
//   //   path: 'services',
//   //   canActivate: [AuthGuard],
//   //   loadComponent: () =>
//   //     import('./shared/components/').then(m => m.DashboardComponent)
//   // },
//   {
//     path: 'qr-scan',
//     canActivate: [AuthGuard],
//     loadComponent: () =>
//       import('./modules/qr-scan/qr-scan.component').then(m => m.QrScanComponent)
//   },
//   {
//     path: 'no-access',
//     loadComponent: () =>
//       import('./modules/no-access/no-access.component').then(m => m.NoAccessComponent)
//   },
//   {
//     path: '**',
//     redirectTo: 'login'
//   }
// ];



// // OLD - BEFORE STANDALONE MIGRATION
// // import { Routes } from '@angular/router';
// // import { DashboardComponent } from './modules/dashboard/dashboard.component';
// // import { RolesComponent } from './modules/roles/roles.component';

// // export const routes: Routes = [
// //   { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
// //   { path: 'dashboard', component: DashboardComponent },
// //   { path: 'roles', component: RolesComponent },
// // ];

// // // _________________________________________________________________
// // import { Routes } from '@angular/router';
// // import { AuthGuard } from './shared/guards/auth.guard';

// // import { AdminLayoutComponent } from './shared/layouts/admin/admin-layout.component';
// // import { AuthLayoutComponent } from './shared/layouts/auth/auth-layout.component';
// // import { QrScanComponent } from './modules/qr-scan/qr-scan.component';
// // import { NoAccessComponent } from './modules/no-access/no-access.component';
// // import { DashboardComponent } from './modules/dashboard/dashboard.component';

// // export const AppRoutes: Routes = [
// //     // {
// //     //     path: '',
// //     //     redirectTo: 'login',
// //     //     pathMatch: 'full',
// //     // },
// //     {
// //         path: '',
// //         component: DashboardComponent,
// //         children: [
// //             {
// //                 path: '',
// //                 loadChildren: () => import('./modules/dashboard/dashboard.component').then(m => m.DashboardComponent),
// //             }
// //         ]
// //     },
// //     // {
// //     //     path: 'qr-scan',
// //     //     component: AdminLayoutComponent,
// //     //     canActivate: [AuthGuard],
// //     //     children: [
// //     //         {
// //     //             path: '',
// //     //             // loadChildren: () => import('./modules/waiter-qr-scan/waiter-qr-scan.module').then(m => m.WaiterQRScanModule),
// //     //         },
// //     //     ]
// //     // },
// //     // {
// //     //     path: 'admin',
// //     //     component: AdminLayoutComponent,
// //     //     canActivate: [AuthGuard],
// //     //     children: [
// //     //         {
// //     //             path: '',
// //     //             loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
// //     //         },
// //     //     ]
// //     // },
// //     // {
// //     //     path: 'menu',
// //     //     component: QrScanComponent,
// //     //     children: [
// //     //         {
// //     //             path: '',
// //     //             loadChildren: () => import('./modules/qr-scan/qr-scan.module').then(m => m.QRScanModule),
// //     //         },
// //     //     ]
// //     // },
// //     // {
// //     //     path: 'no-access',
// //     //     component: NoAccessComponent,
// //     // },
// //     // {
// //     //     path: 'print',
// //     //     loadChildren: () => import('./modules/print/print.module').then(m => m.PrintModule),
// //     // },
// //     // {
// //     //     path: '**',
// //     //     pathMatch: 'full',
// //     //     redirectTo: 'menu',
// //     // }
// // ];